<template>
  <div class="container-00">

    <div class="osc-block-00 osc-border-00 card-00">
      <div class="card-title-00">
        {{ parameter_group_title }} &nbsp;
        <v-btn x-small icon v-on:click="dump_amp_param()"><v-icon>mdi-text-box-outline</v-icon></v-btn>
      </div>

      <!-- --------------------- -->
      <div class="slider-block-00">
        <div class="slider-00-child-00">
          <div class="slider-label-00">LEVEL</div>
          <div class="slider-ctrl-00"><webaudio-slider width="20" id="slider10" direction="vert" colors="#fff;#444;#fff" min="0" max="127" :value="amp_param.ampLevel" v-on:change="onUpdateParam('ampLevel', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="Master Level<br/>%d %"></webaudio-slider></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
 export default {
   name: 'Amp',
   props: ['parameter_group_title', 'label', 'ampvalue'],
   methods: {
     dump_amp_param: function() {
       const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
       const workingPatch = this.$store.getters.getOneEditPatch(workingPatch_idx)
       console.log(`[store:${this.label}]`, workingPatch.decoded)
       console.log(`[local:${this.label}]`, this.$data.amp_param)
       //console.log(`[${this.label}]`, this.$data.amp_param)
     },
     onUpdateParam: function(key, val) {
       //const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
       //const workingPatch = this.$store.getters.getOneEditPatch(workingPatch_idx)
       //console.log(this.noisegen_param, key, val, this.label, this.$data, workingPatch)
       this.$set(this.$data.amp_param, key, val)
       console.log(`[Amp.vue] onUpdateParam key=[${key}]`)
       this.$store.commit('onEditOneEditPatch', {arr_idx: [key], value: Uint8Array.from([val])})

       // let PatchNumNameCard component to recognise params change
       this.$router.app.$children[0].updateParamIsSyncedApp()
     }

   },
   created: function() {
     this.$data.amp_param['ampLevel'] = this.ampvalue
     console.log(this.ampvalue)
     console.log('[REFS]', this)
     //const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
     //const workingPatch = this.$store.getters.getOneEditPatch(workingPatch_idx)
     //console.log(workingPatch)
   },
   computed: {
     testCount: {
       get () {
         return this.$store.getters.getTestCount()
       },
       //set (value) {
       //this.$store.commit('onTestChange', value)
       //}
     }
   },
   data: () => ({
     amp_param: {
       ampLevel: 0
     }
   })
 }
</script>
